/**
 * @generated SignedSource<<53b07cffb3a1055f1132750fea89c9fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ThreadSubscriptionFormAction = "NONE" | "SUBSCRIBE" | "UNSUBSCRIBE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type StickySubscribeButtonRefetchableFragment$data = {
  readonly id: string;
  readonly viewerThreadSubscriptionFormAction: ThreadSubscriptionFormAction | null | undefined;
  readonly " $fragmentType": "StickySubscribeButtonRefetchableFragment";
};
export type StickySubscribeButtonRefetchableFragment$key = {
  readonly " $data"?: StickySubscribeButtonRefetchableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StickySubscribeButtonRefetchableFragment">;
};

import StickySubscribeButtonRefetchableFragmentQuery_graphql from './StickySubscribeButtonRefetchableFragmentQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": StickySubscribeButtonRefetchableFragmentQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "StickySubscribeButtonRefetchableFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerThreadSubscriptionFormAction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "b61c64bf2c95984e70937fa459f33eb7";

export default node;
